<template>
  <b-container fluid class="h-100">
    <b-row align-v="center" align-h="center" class="h-100 pb-5">
      <div style="max-width: 336px">
        <div class="d-flex mb-4">
          <landing-logo size="60px" />
        </div>

        <div id="sign-in" class="h5 display-4 mt-1 mb-3 font-weight-bold">Sign in</div>

        <DuplicateEmailError v-if="errorAuth === 'DUPLICATE_EMAIL'" :auth-type="'USER_PASSS'" />
        <MissingDataError v-if="errorAuth === 'MISSING_LASTNAME'" />
        <ButtonGoogleAuth v-if="$_isFeatureEnabled('google_auth')" />
        <DuplicateEmailError v-if="isShowAlert" :auth-type="'GOOGLE'" />
        <!-- <div
          class="d-flex flex-column align-items-center mb-4 p-4 bg-secondary rounded"
          >
          <span class="text-dark"> Sign in with </span>
          <b-button
          variant="primary"
          class="w-100 mt-3"
          @click="signInWithMsal"
          >
          <span v-if="!isLoadingMsal">KMUTT account</span>
          <span v-else class="pr-2 pl-2">
            <b-spinner label="Loading..." variant="secondary" small />
          </span>
        </b-button>
      </div>-->

        <b-alert
          v-if="errorMessage"
          show
          class="d-flex align-items-center pl-2 align-content-center"
          variant="danger"
        >
          <span class="ml-3">{{ errorMessage }}</span>
        </b-alert>

        <b-form @submit.prevent="signIn">
          <b-form-group label="Email">
            <b-form-input
              id="email"
              v-model="$v.form.email.$model"
              type="text"
              name="email"
              placeholder="Enter your email (example@mail.com)"
              :formatter="emailFormatter"
              :class="[!$v.form.email.$model && $v.form.email.$anyDirty ? 'border-danger' : '']"
              @click="resetErrorMessage"
            />
            <div
              v-if="!$v.form.email.$model && $v.form.email.$anyDirty"
              class="small text-danger mt-1"
            >
              Email is required
            </div>
          </b-form-group>

          <b-form-group label="Password">
            <b-form-input
              id="password"
              v-model="$v.form.password.$model"
              name="password"
              :type="`${isShowPassword ? 'text' : 'password'}`"
              placeholder="Enter your password"
              :class="[
                !$v.form.password.$model && $v.form.password.$anyDirty ? 'border-danger' : ''
              ]"
              disable-value-track
              @click="resetErrorMessage"
            />
            <div
              v-if="!$v.form.password.$model && $v.form.password.$anyDirty"
              class="small text-danger mt-1"
            >
              Password is required
            </div>
          </b-form-group>

          <div>
            <b-form-checkbox
              v-model="isShowPassword"
              name="show-password"
              aria-describedby="flavours"
              aria-controls="flavours"
              >Show password</b-form-checkbox
            >
          </div>

          <VueRecaptcha
            v-if="isLoginAttemptLimited()"
            ref="recaptcha"
            :sitekey="$firebaseRecaptchaSiteKey"
            class="mt-4"
            @verify="onRecaptchaVerify"
            @expired="onRecaptchaExpired"
            @error="onRecaptchaError"
          />
          <div v-if="showCaptchaAlert" class="small text-danger mt-1">
            Please check the checkbox.
          </div>

          <div class="mt-4">
            <b-button type="submit" class="w-100" variant="first">
              <span v-if="!isLoading">Sign in</span>
              <span v-else class="pr-2 pl-2">
                <b-spinner label="Loading..." variant="secondary" small />
              </span>
            </b-button>
          </div>
        </b-form>

        <div class="mt-4">
          <span class="text-dark">
            Don't have an account?
            <router-link :to="signUpPage">Sign up</router-link>
          </span>
        </div>

        <div class="mt-3">
          <span class="text-dark">
            Forgotten password?
            <router-link :to="forgotPasswordPage">Reset your password</router-link>
          </span>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import {
  getAuth,
  // signInWithEmailAndPassword,
  OAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { channelMixin } from '@/mixins/channelMixin';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { zendeskMixin } from '@/mixins/zendeskMixin';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';
import { Utility } from '@/models/Utility';
import { required } from 'vuelidate/lib/validators';
import { VueRecaptcha } from 'vue-recaptcha';
import { useAuth } from '../../composables';
import LandingLogo from '@/components/layout/LandingLogo.vue';
import { useInputFormatter } from '@/composables/useInputFormatter';
import ButtonGoogleAuth from './components/ButtonGoogleAuth.vue';
import MissingDataError from './components/MissingDataError.vue';
import DuplicateEmailError from './components/DuplicateEmailError.vue';

import { optimizelyMixin } from '@/mixins/optimizelyMixin';
const { isLoginAttemptLimited, getLoginAttemptCount, login } = useAuth();
const { email: emailFormatter } = useInputFormatter();

export default {
  components: {
    VueRecaptcha,
    LandingLogo,
    ButtonGoogleAuth,
    MissingDataError,
    DuplicateEmailError
  },

  mixins: [channelMixin, userInfoMixin, zendeskMixin, amplitudeMixin, optimizelyMixin],

  data: () => ({
    isLoading: false,
    isLoadingMsal: false,
    isShowPassword: false,
    errorMessage: '',
    form: {
      email: '',
      password: ''
    },
    prevRoute: '',
    // loginAttempt: 0,
    captchaToken: null,
    showCaptchaAlert: false,
    isShowAlert: false
  }),

  validations() {
    return {
      form: {
        email: { required },
        password: { required }
      }
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  // created() {
  //   this.init();
  // },

  computed: {
    signUpPage() {
      const queryWithoutError = { ...this.$route.query };
      delete queryWithoutError.error;
      return { name: 'SignUp', query: queryWithoutError };
    },

    forgotPasswordPage() {
      return { name: 'forgot-password', query: this.$route.query };
    },
    errorAuth() {
      return this.$route.query.error;
    }
  },

  methods: {
    getLoginAttemptCount,
    isLoginAttemptLimited,
    emailFormatter,

    async signIn() {
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {
        console.log('need input all required field');
        return;
      }

      // Store previousPath if it exists for post-authentication redirect
      const previousPath = this.$route.query.previousPath;
      if (previousPath) {
        localStorage.setItem('previousPath', previousPath);
      } else {
        localStorage.removeItem('previousPath');
      }

      const isLoginLimited = isLoginAttemptLimited();
      /* require captcha */
      const loginAttemptCount = getLoginAttemptCount();

      console.log('count login attempt: ', isLoginLimited);
      let captchaPayload = {};

      if (isLoginLimited) {
        if (this.captchaToken) {
          captchaPayload = {
            CaptchaToken: this.captchaToken,
            isCaptchaTokenVerified: true
          };
          console.log('captcha: ', this.captchaToken);
          try {
            const result = await Utility.api().verifyCaptcha(this.captchaToken);
            if (!result.response.data.success) {
              captchaPayload.isCaptchaTokenVerified = false;
              captchaPayload.Message = `Captcha token fail: ${result.response.data}`;
              console.log('captcha token fail', result.response.data);
              return;
            }
          } catch (error) {
            captchaPayload.isCaptchaTokenVerified = false;
            captchaPayload.Message = error;
            console.log('captcha error: ', error);
            return;
          }
        } else {
          captchaPayload.isCaptchaTokenVerified = false;
          captchaPayload.Message = 'Required check the checkbox.';
          console.log('required check the checkbox.');
          this.showCaptchaAlert = true;
          return;
        }
        this.$_amplitudeMixin_onCheck(captchaPayload);
      }

      this.isLoading = true;
      let isSignedIn = true;
      try {
        await login(this.form.email, this.form.password);

        if (isLoginLimited) {
          this.captchaToken = null;
          this.showCaptchaAlert = false;
          this.$refs.recaptcha.reset();
        }

        await this.goBackAfterSignIn();
      } catch (error) {
        isSignedIn = false;
        const navigationFailureTypeRedirected =
          this.$router.constructor.NavigationFailureType.redirected;

        if (this.$router.constructor.isNavigationFailure(error, navigationFailureTypeRedirected)) {
          return;
        } else {
          console.log('error: ', error);

          if (error.message === 'DUPLICATE_GMAIL') {
            this.isShowAlert = true;
          } else {
            this.errorMessage = error.message;
          }
        }
      } finally {
        this.isLoading = false;
        let payload = {
          IsSignedIn: isSignedIn,
          loginAttempt: loginAttemptCount
        };
        if (this.errorMessage && !isSignedIn) {
          payload.Message = this.errorMessage;
        }
        this.$refs.recaptcha.reset();
        this.$_amplitudeMixin_onCheck(payload);
      }
    },

    async signInWithMsal() {
      const provider = new OAuthProvider('microsoft.com');

      // https://stackoverflow.com/questions/61324019/error-getting-verification-code-from-microsoft-with-firebase-and-azure
      provider.setCustomParameters({
        prompt: 'consent',
        tenant: '6f4432dc-20d2-441d-b1db-ac3380ba633d'
      });

      try {
        const result = await signInWithPopup(getAuth(), provider);
        console.log('sign in with msal: ', result);
        console.log('user: ', getAuth().currentUser);
        console.log('token: ', await getAuth().currentUser.getIdToken());

        await this.goBackAfterSignIn();
      } catch (error) {
        console.log(error);
        this.errorMessage = 'Cannot sign in with microsoft, please try again';
        this.$sentry.captureException(error);
      }
    },

    onRecaptchaVerify(token) {
      console.log('recaptcha verify: ', token);
      this.captchaToken = token;
    },

    onRecaptchaExpired() {
      console.log('recaptcha expired');
      this.captchaToken = null;
    },

    onRecaptchaError(e) {
      console.log('recaptcha error: ', e);
      this.captchaToken = null;
    },

    async goBackAfterSignIn() {
      // const result = await loadUserData();

      // if (result === null) {
      //   sessionStorage.setItem('kmutt4life__temp-password', this.form.password);

      //   return this.$router.replace({ name: 'SignUp' });
      // }
      if (this.$_isFeatureEnabled('onboarding')) {
        if (this.user && !this.user.is_onboarded) {
          return this.$router.push({ name: 'on-boarding' });
        }
      }

      // Clean up stored previousPath after successful sign-in
      localStorage.removeItem('previousPath');

      if (this.$route.query.redirectUrl) {
        location.assign(decodeURIComponent(this.$route.query.redirectUrl));
        return;
      }

      if (this.$route.query.previousPath) {
        const { previousPath, payload } = this.$route.query;

        return this.$router.push({
          path: previousPath,
          query: {
            payload
          }
        });
      } else {
        return this.$router.push({ path: '/' });
      }
    },

    resetErrorMessage() {
      this.errorMessage = '';
    }
  }
};
</script>
